import { useEffect, useState } from 'react'
import { Shield } from 'lucide-react'
import api from '../../services/api'

export default function WorkersCompList() {
  const [claims, setClaims] = useState<any[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    api.get('/workers-comp').then(r => setClaims(r.data)).finally(() => setLoading(false))
  }, [])

  const STATUS_BADGE: Record<string, string> = { lodged: 'badge-medium', accepted: 'badge-low', disputed: 'badge-high', closed: 'badge-medium' }

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold" style={{ color: 'var(--text)' }}>Workers Compensation</h1>
          <p className="text-sm mt-0.5" style={{ color: 'var(--text-muted)' }}>{claims.length} claims</p>
        </div>
      </div>

      {loading ? <div className="text-center py-12" style={{ color: 'var(--text-muted)' }}>Loading...</div> :
        claims.length === 0 ? (
          <div className="card text-center py-16">
            <Shield size={40} className="mx-auto mb-3" style={{ color: 'var(--text-muted)' }} />
            <p style={{ color: 'var(--text-muted)' }}>No workers comp claims recorded</p>
            <p className="text-sm mt-1" style={{ color: 'var(--text-muted)' }}>Claims are created from incidents</p>
          </div>
        ) : (
          <div className="card p-0 overflow-hidden">
            <table className="w-full text-sm">
              <thead>
                <tr style={{ borderBottom: '1px solid var(--border)', background: 'var(--bg)' }}>
                  <th className="text-left px-4 py-3 font-semibold" style={{ color: 'var(--text-secondary)' }}>Claim</th>
                  <th className="text-left px-4 py-3 font-semibold" style={{ color: 'var(--text-secondary)' }}>Worker</th>
                  <th className="text-left px-4 py-3 font-semibold" style={{ color: 'var(--text-secondary)' }}>Insurer</th>
                  <th className="text-left px-4 py-3 font-semibold" style={{ color: 'var(--text-secondary)' }}>Injury Date</th>
                  <th className="text-left px-4 py-3 font-semibold" style={{ color: 'var(--text-secondary)' }}>Total Cost</th>
                  <th className="text-left px-4 py-3 font-semibold" style={{ color: 'var(--text-secondary)' }}>Status</th>
                </tr>
              </thead>
              <tbody>
                {claims.map(c => (
                  <tr key={c.id} style={{ borderBottom: '1px solid var(--border)' }}>
                    <td className="px-4 py-3 font-mono text-xs" style={{ color: 'var(--accent)' }}>{c.claim_number || 'No claim #'}</td>
                    <td className="px-4 py-3" style={{ color: 'var(--text)' }}>{c.worker_name || '—'}</td>
                    <td className="px-4 py-3" style={{ color: 'var(--text-secondary)' }}>{c.insurer}</td>
                    <td className="px-4 py-3 text-xs" style={{ color: 'var(--text-secondary)' }}>{c.date_of_injury ? new Date(c.date_of_injury).toLocaleDateString('en-AU') : '—'}</td>
                    <td className="px-4 py-3" style={{ color: 'var(--text)' }}>{c.total_cost ? `$${c.total_cost.toLocaleString()}` : '—'}</td>
                    <td className="px-4 py-3">
                      <span className={`badge ${STATUS_BADGE[c.claim_status] || ''} capitalize`}>{c.claim_status}</span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
    </div>
  )
}
